import React, { useEffect, useState } from "react"
import { Row, Table } from "reactstrap"
import Loader from "pages/Separate/Loader"
import configure from "configure"
import axios from "axios"
import secureLocalStorage from "react-secure-storage"
import { getInitials } from "utils/common-helpers"

const Documents = ({ id, verticalActiveTab }) => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const getDocuments = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("staff_id", id)
    const bearerToken = secureLocalStorage.getItem("auth_token")
    try {
      const response = await axios({
        method: "get", 
        url: `${configure.nodeApi}/employeeJoining/showStaffDocument/${id}`,
        data: formData,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        const modifyArray = response?.data?.data?.filter(item => {
          const type = ["enrollingdocuments", "zithasdocuments"]
          const itemtypes = item.requirement_type
            ?.replace(/\s+/g, "")
            .toLowerCase()
          return type.includes(itemtypes)
        })
        setData(modifyArray)
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }
  useEffect(() => {
    if (verticalActiveTab == "5") {
      if (data?.length == 0) {
        getDocuments()
      }
    }
  }, [verticalActiveTab])
  return (
    <>
      {isLoading && <Loader />}
      <div>
        <div>
          <div className="mb-3 p-4 bg-white shadow">
            <Row>
              <div className="col-md-6">
                <h4 className="text-dark mb-3">Staff Documents</h4>
              </div>

            </Row>

            <div className=" bg-white ">
              <Row className="mt-4">
                <div className="col-12">
                  <Table className="table table-striped table-bordered table-hover shadow">
                    <thead>
                      <tr>
                        <th className="col-1 text-center">Sr.No</th>
                        <th className="col-3">Document Name</th>
                        <th>Document Type</th>
                        <th className="text-center">Uploaded By</th>
                        <th className="text-center">Approved By</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((ob, index) => {
                        return (
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>
                            <td>{ob.file_name}</td>
                            <td>{ob.requirement_type}</td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-2 align-items-center">
                                {ob.uploaded_by_details?.avatar ? (
                                  <img
                                    src={`${configure.imgUrl}${ob.uploaded_by_details?.avatar}`}
                                    alt="Avatar"
                                    title={ob.uploaded_by_details?.name} // tooltip for hover
                                    className="img-fluid rounded-circle"
                                    width={22}
                                    height={22}
                                  />
                                ) : (
                                  <div
                                    className="defualt-img rounded-circle d-flex align-items-center justify-content-center"
                                    title={ob.uploaded_by_details?.name}
                                    style={{
                                      width: 22,
                                      height: 22,
                                      fontSize: 10,
                                    }}
                                  >
                                    {getInitials(ob.uploaded_by_details?.name)}
                                  </div>
                                )}
                                {ob.uploaded_by_details?.name || "N/A"}

                              </div>
                            </td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-2 align-items-center">
                                {ob.approved_by_details?.avatar ? (
                                  <img
                                    src={`${configure.imgUrl}${ob.approved_by_details?.avatar}`}
                                    alt="Avatar"
                                    title={ob.approved_by_details?.name} // tooltip for hover
                                    className="img-fluid rounded-circle"
                                    width={22}
                                    height={22}
                                  />
                                ) : (
                                  <div
                                    className="defualt-img rounded-circle d-flex align-items-center justify-content-center"
                                    title={ob.approved_by_details?.name}
                                    style={{
                                      width: 22,
                                      height: 22,
                                      fontSize: 10,
                                    }}
                                  >
                                    {getInitials(ob.approved_by_details?.name)}
                                  </div>
                                )}
                                {ob.approved_by_details?.name || "N/A"}

                              </div>
                            </td>
                            <td className="text-center"> 
                              <a
                                // type="button"
                                href={ob.link}
                                target="_blank"
                                className="btn btn-sm me-1 btn-outline-secondary"
                                // onClick={() => downloadImage(ob.link)}
                                title="Download Document"
                                rel="noreferrer"
                              >
                                <i className="fa fa-eye"></i>
                              </a> 
                            </td>
                          </tr>
                        )
                      })}
                      {data.length == 0 && (
                        <tr>
                          <td colSpan={8} className="text-center">
                            {" "}
                            No Document Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Documents
